import React, { useState } from "react";
import { Typography, Button, Row, Col, Modal, message } from "antd";

import { CirclePicker } from "react-color";

import lightImage from "../../../assets/images/lightTheme.png";
import darkTheme from "../../../assets/images/darkTheme.png";
import TestimonialService from "../../../services/TestimonialService";
import { useSelector } from "react-redux";
import CustomizationService from "../../../services/CustomizationService";


const { Title } = Typography;

export default function ThemePopup({open,close,theme, setTheme}) {

  const adminRestaurant = useSelector((state) => state.admin);
  const [selectedBrand, SetBrandColor] = useState()
  const getSelectedBrand =(e,v)=>{
    console.log(e,v)
  SetBrandColor(e.hex)

  }
  const updateTheme =async()=>{
    const payload = {
      theme: theme,
      brand_color:selectedBrand
    }
    await CustomizationService.saveCustomization(
      
      adminRestaurant,
      payload
    );
    message.success("Updated Successfully");
    close()
  }
 
  return (
    <Modal footer={null} open={open} width={720} onCancel={() => close()}>
      <div style={{ padding: 20 }}>
        <Row>
          <Col span={24}>
            <Title level={4}>Update Website Theme</Title>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="d-flex mt-2">
              <div>
                <div
                  style={{
                    cursor: "pointer",
                    margin: 10,
                    borderRadius: 8,
                    border: `4px solid ${
                      theme === "LIGHT" ? "#C32340" : "rgba(58, 58, 58, 0.4)"
                    }`,
                  }}
                  onClick={() => setTheme("LIGHT")}
                >
                  <div>
                    <img
                      src={lightImage}
                      alt="light"
                      width={260}
                      style={{ borderRadius: 8 }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    padding: 10,
                    textAlign: "center",
                    fontWeight: theme === "LIGHT" ? 600 : 400,
                    color:
                      theme === "LIGHT" ? "#C32340" : "rgba(58, 58, 58, 0.4)",
                  }}
                >
                  Light Theme
                </div>
              </div>
              <div>
                <div
                  style={{
                    cursor: "pointer",
                    margin: 10,
                    borderRadius: 8,
                    border: `4px solid ${
                      theme === "DARK" ? "#C32340" : "rgba(58, 58, 58, 0.4)"
                    }`,
                  }}
                  onClick={() => setTheme("DARK")}
                >
                  <div>
                    <img
                      src={darkTheme}
                      alt="dark"
                      width={260}
                      style={{ borderRadius: 8 }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    padding: 10,
                    textAlign: "center",
                    fontWeight: theme === "LIGHT" ? 600 : 400,
                    color:
                      theme === "DARK" ? "#C32340" : "rgba(58, 58, 58, 0.4)",
                  }}
                >
                  Dark Theme
                </div>
              </div>
            </div>
            <div className="d-flex items-center mt-2">
              <div>Brand Color:</div>
              <CirclePicker
                className="ml-1"
                colors={[
                  "#FF3A3A",
                  "#999999",
                  "#F44E3B",
                  "#FE9200",
                  "#FCDC00",
                  "#DBDF00",
                ]}
                onChange={getSelectedBrand}
              />
              {/* <div className="colored-circle ml-1 cursor-pointer"></div> */}
              
            </div>
            {/* <div>
              <SketchPicker
                className="mt-1"
                colors={[
                  "#FF3A3A",
                  "#999999",
                  "#F44E3B",
                  "#FE9200",
                  "#FCDC00",
                  "#DBDF00",
                ]}
              />
            </div> */}
            <div className="d-flex items-center justify-center mt-2">
              <Button type="primary" className="custom-btn" onClick={() => updateTheme()}>
                save
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
}
